module.exports = __webpack_public_path__ + "img/bold-html.36552665.png";